import React from 'react';
import { normalizePictureData } from './normalize';

// Пример формата данных
// обязательно наличие 1x, в массиве сначала обычный формат - далее webp
// брейки передаются по возрастанию в начале
// const data3 = {
//   670: ['670.jpg', '670.webp'],
//   1440: ['1440.jpg', '1440.webp'],
//   1920: ['1920.jpg', '1920.webp'],
//   '1x': ['1234.jpg', '12345.webp'],
//   '2x': ['1234.jpg', '12345.webp'],
// };
export const Picture = ({ data, alt = '', lazy = true, ref, width = '', height = '', decoding = 'auto' }) => {
  const { pictureData, defaultImage } = normalizePictureData(data);

  return (
    <picture>
      {pictureData.map((item, index) => (
        <React.Fragment key={index}>
          {item.srcSet && <source media={item.media && item.media} srcSet={item.srcSet} type={item.type} />}
        </React.Fragment>
      ))}
      <img
        loading={lazy ? 'lazy' : undefined}
        decoding={decoding}
        src={defaultImage.srcSet}
        alt={alt}
        ref={ref}
        width={width}
        height={height}
      />
    </picture>
  );
};
